import { render, staticRenderFns } from "./FileDownLoad.vue?vue&type=template&id=6e722a3c"
import script from "./FileDownLoad.vue?vue&type=script&lang=js"
export * from "./FileDownLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports